import * as React from 'react';

import { useTranslation } from 'react-i18next';

import { CarretIcon, InfoIcon } from '@icons';

import { TransactionType } from '@types';

import { Button } from '@components/button';

import { config } from '@/config.ts';

import * as Styled from './status.styled.ts';

type OwnProps = {
	transaction: TransactionType;
};

const isSk2 = config.BRAND === 'sk2';
const isPmBrand = config.BRAND === 'pm';

const Status: React.FC<OwnProps> = ({ transaction }) => {
	const { t } = useTranslation(['main', 'errors', 'activity_history']);

	const [visibleItem, setIsVisible] = React.useState('');

	const handleShowInfo = (id: string) => {
		setIsVisible(id);
	};

	const handleCloseInfo = () => {
		setIsVisible('');
	};

	const errors = React.useMemo(
		() => ({
			bad_params: t('errors:bad_params'),
			failed: t('errors:failed'),
			bad_buyer: `${t('errors:bad_buyer')}`,
			tradelink_outdated_error: `${t('errors:tradelink_outdated_error')}`,
			tradelink_format_error: t('errors:tradelink_format_error'),
			escrow_restriction_error: t('errors:escrow_restriction_error'),
			private_inventory_error: `${t('errors:private_inventory_error')}`,
			steam_trade_ban_error: `${t('errors:steam_trade_ban_error')}`,
			tradelink_error: `${t('errors:tradelink_error')}`,
			buyer_has_buy_items_ban: t('errors:buyer_has_buy_items_ban'),
			cancelled: t('errors:cancelled'),
			offer_expired: t('errors:offer_expired'),
			offer_declined: t('errors:offer_declined'),
			user_reached_limit_24h: `${t('errors:user_reached_limit_24h')}`,
			default: t('errors:default')
		}),
		[t]
	);

	const statusText = React.useMemo(() => {
		if (transaction?.shop_item?.item_type === 'merch_prize') {
			return t(isSk2 ? 'main:credited' : 'main:delivered');
		} else if (transaction.status === 'pending' || transaction.status === 'sent') {
			return t('main:send');
		} else if (transaction.status === 'completed') {
			return t(isSk2 ? 'main:credited' : 'main:delivered');
		} else {
			return t('main:cancel');
		}
	}, [transaction, t]);

	return (
		<Styled.Wrapper>
			<Styled.StatusItem
				$status={transaction?.shop_item?.item_type === 'merch_prize' ? 'completed' : transaction.status}
				$round={!isPmBrand}
			>
				{statusText}
				{transaction.status === 'failed' && transaction?.shop_item?.item_type !== 'merch_prize' && (
					<Styled.Error>
						<Styled.InfoIconWrapper onClick={() => handleShowInfo(transaction.id)}>
							<InfoIcon />
						</Styled.InfoIconWrapper>

						<Styled.Info $isVisible={transaction.id === visibleItem}>
							<Styled.InfoTitle>{t('cancel_reason')}</Styled.InfoTitle>
							<Styled.InfoText
								dangerouslySetInnerHTML={{
									__html:
										transaction?.shop_item?.item_type === 'rea_bonus' ? errors.user_reached_limit_24h : errors.default
								}}
							></Styled.InfoText>
							<Button onClick={handleCloseInfo} color='light'>
								{t('main:clear')}
							</Button>
							<Styled.Carret>
								<CarretIcon />
							</Styled.Carret>
						</Styled.Info>
					</Styled.Error>
				)}
			</Styled.StatusItem>
		</Styled.Wrapper>
	);
};

export default Status;
